<template>
  <nuxt-child />
</template>

<script>

export default {
  name: "Console",
  layout (context) {
    if (context && context.route && context.route.path) {
      let path = context.route.path.toLowerCase();
      if (path.indexOf("/console") !== -1) {
        return "entconsolelayout";
      }
    }
    return "fullpage";
  },
  watch: {
    $route: {
      handler (val) {
        // 返回到console页面后，跳转回君子签
        if (val.path === "/console") {
          this.$router.push("/viewIndex");
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// pages/console.vue